<template>
  <!-- ConfigManage -->
  <el-tab-pane label="ConfigManage">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">ConfigManage</h4>
            <!-- Start search part -->

            <div class="row">
              <div class="col-sm-3">
                <base-input label="name">
                  <el-input placeholder="name" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKeyConfig.name"></el-input>
                </base-input>
              </div>
              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="searchConfig" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="resetConfig" style="width: 100px">Reset</base-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="margin-top: 20px">
                <el-link type="primary" @click="OpenAddConfig">Add Config</el-link>

                <el-link style="margin-left: 60px" type="primary" @click="ResetConfig">Reset System Config</el-link>
              </div>
            </div>
            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-12" style="display: flex">
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKeyConfig.total"
                    @size-change="ChangePageSearchConfig" @current-change="ChangePageSearchConfig" />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="Configlist" style="width: 100%" border header-row-class-name="header-row"
                  @filter-change="searchConfig" table-layout="auto" cell-class-name="report-cell">
                  <tablecolumn prop="paramType_" label="ParamType" :width="200" />
                  <tablecolumn prop="name" label="Name" :width="250" />

                  <el-table-column prop="content" label="Content">
                    <template #default="scope">
                      <el-popover placement="right" :width="800" trigger="click">
                        <template #reference>
                          <el-button class="m-2">{{ scope.row.content != null ? scope.row.content.substring(0, 50) : null
                            }}</el-button>
                        </template>

                        <div style="overflow-y: auto; ">
                          <pre style="height: 600px; color: black;font-size: 16px;">{{ scope.row.content }}</pre>
                        </div>
                      </el-popover>

                    </template>
                  </el-table-column>


                  <el-table-column prop="flag" label="Flag" :width="80" />
                  <!-- <tablecolumn prop="note" label="Note" :width="300" /> -->
                  <el-table-column prop="note" label="note">
                    <template #default="scope">
                      <el-popover placement="right" :width="800" trigger="click">
                        <template #reference>
                          <el-button class="m-2">{{ scope.row.note != null ? scope.row.note.substring(0, 50)
                            :""}}</el-button>
                        </template>

                        <div style="overflow-y: auto; ">
                          <pre style="height: 600px; color: black;font-size: 16px;">{{ scope.row.note }}</pre>
                        </div>
                      </el-popover>

                    </template>
                  </el-table-column>
                  <el-table-column prop="addTime" label="AddTime" :width="200" />

                  <el-table-column prop="updateTime" label="UpdateTime" :width="200" />
                  <el-table-column prop="" fixed="right" label="Action" :width="150" class-name="action">
                    <template #default="scope">
                      <el-link type="primary" @click="OpenUpdateConfig(scope.row)">Update</el-link>
                      <br />
                      <el-link type="danger" @click="OpenDeleteConfig(scope.row)">Delete</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 添加Config -->
    <div>
      <el-dialog v-model="dialogFormOpenAddConfig" title="Add Configs" :width="800">
        <el-form :model="ConfigInfoData">
          <el-form-item label="ParamType" required :label-width="formLabelWidth">
            <el-input v-model="ConfigInfoData.value.paramType_" autocomplete="off" />
          </el-form-item>

          <el-form-item label="Name" required :label-width="formLabelWidth">
            <el-input v-model="ConfigInfoData.value.name" autocomplete="off" />
          </el-form-item>

          <el-form-item label="Flag" :label-width="formLabelWidth" required>
            <el-select v-model="ConfigInfoData.value.flag">
              <el-option label="true" value="true" />
              <el-option label="false" value="false" />
            </el-select>
          </el-form-item>

          <el-form-item label="Note" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.note" autocomplete="off"
              :autosize="{ minRows: 3 }" />
          </el-form-item>

          <el-form-item label="Content" required :label-width="formLabelWidth">
            <el-input type="textarea" v-model="ConfigInfoData.value.content" autocomplete="off"
              :autosize="{ minRows: 10 }" />
          </el-form-item>
        </el-form>

        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormOpenAddConfig = false">Cancel</el-button>
            <el-button type="primary" @click="AddConfigs"> Confirm </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </el-tab-pane>
</template>

<script setup>
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';

const formLabelWidth = '140px';
const currentPage = ref(1);
const pageSize = ref(10);

// router
import router from '@/router';
import profile from '@/network/profile';

// icon
import { Edit, Search } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await searchConfig();
});

//#region Configs
const Configlist = ref([]);
const dialogFormOpenAddConfig = ref(false);
const dialogFormOpenUpdateConfig = ref(false);
const ConfigInfoData = reactive({});
const userlist = ref([]);

//变更分页
const ChangePageSearchConfig = async (data) => {
  searchKeyConfig.pageIndex = currentPage;
  searchKeyConfig.pageSize = pageSize;
  searchConfig();
};
const searchKeyConfig = reactive({
  pageIndex: 1,
  pageSize: 10,
});

const searchConfig = async () => {
  const search_res = await profile
    .GetConfigList(searchKeyConfig)
    .then((res) => res);
  searchKeyConfig.total = search_res.data.total;
  Configlist.value = search_res.data.list;
  userlist.value = search_res.data.userlist;
};

const resetConfig = async () => {
  //清空对象
  Object.keys(searchKeyConfig).map((key) => {
    delete searchKeyConfig[key];
  });
  searchKeyConfig.pageIndex = 1;
  searchKeyConfig.pageSize = 10;
  searchConfig();
};
//打开添加Config
const OpenAddConfig = async (data) => {
  dialogFormOpenAddConfig.value = true;
  ConfigInfoData.value = { paramType_: 'DataConfig', flag: 'true' };
};

//打开修改窗口
const OpenUpdateConfig = async (data) => {
  dialogFormOpenAddConfig.value = true;
  ConfigInfoData.value = data;
};
//添加Config
const AddConfigs = async (data) => {
  dialogFormOpenAddConfig.value = false;
  const result = await profile
    .AddUpdateConfig(ConfigInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '操作成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await searchConfig();
};
const ResetConfig = async () => {
  ElMessageBox.confirm('Reset system cache ?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.ResetConfig({}).then((res) => res);
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};

//删除
const OpenDeleteConfig = async (data) => {
  ConfigInfoData.value = data;
  ElMessageBox.confirm(
    'Are you sure to delete (' + data.name + ')?',
    'Warning',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
    }
  )
    .then(async () => {
      const result = await profile
        .DeleteConfig(ConfigInfoData.value)
        .then((res) => res);
      if (result.data === '') {
        ElMessage({
          message: '删除成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
      await searchConfig();
    })
    .catch(() => { });
};
//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKeyConfig[`${data.key}`] = data.value;
    searchConfig();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
